import { useState, useCallback, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import SelectCategoriaAtendimento from "../../../../Components/CardsPages/Forms/SelectCategoriaAtendimento";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { useUserInfor } from "../../../../Context/User";
import { ListarProdutosPorContaCompleto } from "../../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";
import { AtualizarAtendimentoController } from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ListarCategoriaAtendimentoAoClienteController } from "../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import { ListarSubCategoriaController } from "../../../../Controllers/Geral/GestaoDeCadastros/SubCategoria/SubCategoriaControllers";
import { ListarCanalAtendimentoContoller } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import { ListarTipoPesoAtendimentoAtivosController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IContaProduto } from "../../../../Interfaces/Cobranca/ContaProduto/ContaProdutoInterface";
import { IAtualizarAtendimento } from "../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import { GetAtendimentoClienteController } from "../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../Components/Utils/OrSpinner";

const controllers = {
    Atendimento: {
        Categoria: ListarCategoriaAtendimentoAoClienteController,
        Subcateogoria: ListarSubCategoriaController,
        Produto: ListarProdutosPorContaCompleto,
        getCaso: GetAtendimentoClienteController,
        id: ACESSOS.ATENDIMENTO.ID_MODULO,
    },
};

interface IEditarAtendimentoProps {
    setShow: (show: boolean) => void;
    update?: () => void;
    AtendimentoRow?: any;
}

export default function EditarAtendimento(props: IEditarAtendimentoProps) {
    const { ReloadHistorico } = useHistoricoContext();
    const { UserInfor } = useUserInfor();
    const { updateAtendimento, idModulo } = useAtendimentoPage();
    const formMethods = useForm();
    const {
        handleSubmit,
        watch,
        setValue,
        setError,
        clearErrors,
        register,
        control,
        formState,
    } = formMethods;

    const [produtos, setProdutos] = useState<Array<IContaProduto>>([]);
    const [showJustificativa, setShowJustificativa] = useState(false);
    const [idConta, setIdConta] = useState(0);

    useEffect(() => {
        controllers["Atendimento"]
            .getCaso(props.AtendimentoRow.ID_CASO)
            .then((res) => {
                setIdConta(res.ID_CONTA);
            })
            .finally();
    }, [props.AtendimentoRow.ID_CASO]);

    const dtExpectativaInicial = props.AtendimentoRow?.DT_EXPECTATIVA_CONCLUSAO
        ? props.AtendimentoRow?.DT_EXPECTATIVA_CONCLUSAO.split("T")[0]
        : props.AtendimentoRow?.DT_SLA?.split("T")[0];

    const dtExpectativaInicialProps =
        props?.AtendimentoRow?.DT_REAL_CONCLUSAO?.split("T")[0];

    const watchDtExpectativaNova = watch("DT_EXPECTATIVA_NOVA");

    const ListarProdutosCliente = useCallback(async () => {
        if (idConta) {
            return controllers["Atendimento"].Produto(idConta, 2);
        } else {
            return [] as Array<IContaProduto>;
        }
    }, [idConta]);

    const ListarSubCategorias = useCallback(
        async (idCategoria: number, idUnidade: number) => {
            const idEmpreendimento = produtos.find(
                (p) => p.UNIDADE.ID_UNIDADE === idUnidade
            )?.ID_EMPREENDIMENTO;
            return ListarSubCategoriaController(idCategoria, idEmpreendimento);
        },
        [produtos]
    );

    const { loading: atualizando, execute: handleEditarAtendimentoFormSubmit } =
        useAsyncCallback(async (formdata: IAtualizarAtendimento) => {
            if (props.AtendimentoRow?.ID_CASO) {
                await AtualizarAtendimentoController(
                    props.AtendimentoRow?.ID_CASO,
                    {
                        ...formdata,
                        ID_TIPO_CASO: idModulo,
                        DT_EXPECTATIVA_ANTERIOR: dtExpectativaInicial,
                    }
                ).then(() => {
                    props.setShow(false);
                    if (!props.AtendimentoRow?.ID_CASO) {
                        updateAtendimento();
                        ReloadHistorico();
                    } else if (props.AtendimentoRow?.ID_CASO) {
                        if (props?.update) {
                            props.update();
                        }
                    }
                });
            }
        });

    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    useEffect(() => {
        if (
            watchDtExpectativaNova &&
            watchDtExpectativaNova !== dtExpectativaInicial
        ) {
            setShowJustificativa(true);
        } else {
            setShowJustificativa(false);
        }
    }, [
        watchDtExpectativaNova,
        dtExpectativaInicial,
        setError,
        clearErrors,
        setValue,
    ]);

    const { id } = useModuloInfo();

    const {
        value: lstTipoPesoAtendimento,
        loading: lstTipoPesoAtendimentoLoading,
    } = useAsyncEffect(async () => {
        if (id) return ListarTipoPesoAtendimentoAtivosController(id);
    }, [id]);

    return (
        <OrSpinner loading={lstTipoPesoAtendimentoLoading} spinner="capys">
            <form onSubmit={handleSubmit(handleEditarAtendimentoFormSubmit)}>
                {props.AtendimentoRow && (
                    <LazySelect
                        label="Produto"
                        name="ID_PRODUTO"
                        controller={ListarProdutosCliente}
                        defaultValue={
                            props.AtendimentoRow?.PRODUTO?.UNIDADE
                                ?.ID_UNIDADE ?? 0
                        }
                        getDS={(p) =>
                            `${p.DS_EMPREENDIMENTO} - ${p.UNIDADE.DS_UNIDADE}`
                        }
                        getKeyValue={(p) => p.UNIDADE.ID_UNIDADE}
                        {...formMethods}
                        registerOptions={{
                            required: "Insira o produto",
                            valueAsNumber: true,
                        }}
                        onOptionsLoad={setProdutos}
                        className="form-control mb-2"
                    />
                )}
                <label>Categoria de Atendimento</label>
                <SelectCategoriaAtendimento
                    name="ID_CATEGORIA_ATENDIMENTO"
                    ID_MODULO={idModulo}
                    defaultValue={
                        props?.AtendimentoRow?.ID_CATEGORIA_ATENDIMENTO
                    }
                    control={control}
                    rules={{
                        required: "Insira a categoria de Atendimento",
                    }}
                    className="form-control mb-2"
                />
                {props.AtendimentoRow && (
                    <LazySelect
                        label="Subcategoria"
                        name="ID_SUBCATEGORIA_ATENDIMENTO"
                        parentsNames={[
                            "ID_CATEGORIA_ATENDIMENTO",
                            "ID_PRODUTO",
                        ]}
                        controller={ListarSubCategorias}
                        defaultValue={props?.AtendimentoRow?.ID_SUBCATEGORIA}
                        getDS={(s) => s.DS_SUBCATEGORIA_ATENDIMENTO}
                        getKeyValue={(s) => s.ID_SUB_CATEGORIA_ATENDIMENTO}
                        {...formMethods}
                        registerOptions={{
                            valueAsNumber: true,
                        }}
                        className="form-control mb-2"
                    >
                        <option value={0}></option>
                    </LazySelect>
                )}
                <label>Peso</label>
                <select
                    name="ID_TIPO_PESO_ATENDIMENTO"
                    defaultValue={
                        props.AtendimentoRow?.PESO_ATENDIMENTO
                            .ID_TIPO_PESO_ATENDIMENTO
                    }
                    disabled={
                        !UserInfor.FUNCOES.some(
                            (f) => f.NM_FUNCAO === "ADM_EDITA_PESO_ATENDIMENTO"
                        )
                    }
                    {...formMethods}
                    ref={register()}
                    className="form-control mb-2"
                >
                    <option value={0}></option>
                    {lstTipoPesoAtendimento?.map((tpa) => (
                        <option
                            key={tpa.ID_TIPO_PESO_ATENDIMENTO}
                            value={tpa.ID_TIPO_PESO_ATENDIMENTO}
                        >
                            {tpa.DS_TIPO_PESO_ATENDIMENTO}
                        </option>
                    ))}
                </select>

                <LazySelect
                    label="Canal de Atendimento"
                    name="ID_TIPO_CANAL_ATENDIMENTO"
                    controller={listarCanalAtendimento}
                    defaultValue={
                        props.AtendimentoRow?.ID_TIPO_CANAL_ATENDIMENTO
                    }
                    getDS={(c) => c.DS_TIPO_CANAL_ATENDIMENTO}
                    getKeyValue={(c) => c.ID_TIPO_CANAL_ATENDIMENTO}
                    {...formMethods}
                    registerOptions={{
                        required: "Insira o Canal de Atendimento",
                        valueAsNumber: true,
                    }}
                    className="form-control mb-2"
                />
                {
                    <>
                        <label>Expectativa Real de Conclusão</label>
                        <input
                            name="DT_EXPECTATIVA_NOVA"
                            ref={register()}
                            className="form-control mb-2"
                            type="date"
                            defaultValue={
                                dtExpectativaInicial ??
                                dtExpectativaInicialProps
                            }
                        />
                        {showJustificativa && (
                            <div>
                                <label>Justificativa</label>
                                <textarea
                                    name="DS_MOTIVO"
                                    ref={register({
                                        required: showJustificativa
                                            ? "Insira a justificativa"
                                            : false,
                                    })}
                                    className={`form-control mb-2 ${
                                        formState.errors.DS_MOTIVO &&
                                        "is-invalid"
                                    }`}
                                />
                                <div className="invalid-feedback">
                                    {formState.errors.DS_MOTIVO
                                        ? formState.errors.DS_MOTIVO.message
                                        : ""}
                                </div>
                            </div>
                        )}{" "}
                    </>
                }

                <div className="d-flex mt-5">
                    <button
                        type="submit"
                        className="btn btn-block btn-outline-success d-flex align-items-center justify-content-center g-2"
                        disabled={atualizando}
                    >
                        {atualizando && (
                            <Spinner size="sm" animation={"grow"} />
                        )}
                        Confirmar atualização
                    </button>
                </div>
            </form>
        </OrSpinner>
    );
}
